var modules_2fd5ce57 = {"arrows":"Arrows_module_arrows__c8dce3c1","important":"Arrows_module_important__c8dce3c1","arrow":"Arrows_module_arrow__c8dce3c1","disabled":"Arrows_module_disabled__c8dce3c1","icon":"Arrows_module_icon__c8dce3c1","right-arrow":"Arrows_module_rightArrow__c8dce3c1","left-arrow":"Arrows_module_leftArrow__c8dce3c1"};
import "../../../assets/esm/components/Carousel/src/Arrows~CaFNrQM2.css";

export { modules_2fd5ce57 as default };
//# sourceMappingURL=Arrows.module.less.js.map
